import Button from '@components/Button';
import TextField from '@components/TextField';
import Table from '@components/Table';
import CreateRegionModal from './partials/CreateRegionModal';
import Icon from '@material-ui/core/Icon';
import { useState, useEffect } from 'react';
import { apiClient } from '@services/api';
import BreadCrumbs from '@components/Breadcrumbs';
import StatusSwitch from '@components/StatusSwitch';

const permissions = ['administrador'];

const Index = (props) => {
  document.title = `Lista de translados - ${process.env.REACT_APP_NAME}`
  let [rows] = useState([]);
  let [q, setQ] = useState("");
  const [open, setOpen] = useState(false);

  const bradecrumbsConfig = [
    {
      title: 'Início',
    }
  ]

  //Oculta menu lateral
  useEffect(() => {
    props.setShowMenu(false)
  }, []);

  return <>
    <div className="px-7">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue mb-3">
        <div className="flex items-center">
          <Icon className="mr-2">
            flight
          </Icon>
          <span>Lista de zonas</span>
        </div>
        {permissions.includes(props?.theme?.permission) && <Button
          textcolor="#fff"
          padding="6px 15px"
          margintop="0px"
          width="200"
          onClick={() => setOpen(true)}
          customcolor={props.theme.color}><Icon className="mr-2">add</Icon> Novo</Button>}
        <CreateRegionModal
          theme={props.theme}
          open={open}
          close={() => setOpen(false)} />
      </div>
      <div className="p-4 mt-4 bg-white border-1" style={{borderRadius: '10px 10px 0px 0px'}}>
        <div className="flex flex-wrap items-center">
          <TextField
            className="inputRounded"
            placeholder="Busque por uma região"
            variant="outlined"
            type="text"
            name="q"
            onChange={(e) => setQ(e.target.value)}
            required></TextField>
        </div>
      </div>
      <Table
        params={{
          q
        }}
        path="/translados"
        columns={[
            {
              headerName: 'Zona',
              headerClassName: 'super-app-theme--header',
              field: 'region_name',
              width: 560,
            },
            {
              headerName: 'Status',
              headerClassName: 'super-app-theme--header',
              field: 'status',
              headerAlign: 'right',
              align: 'right',
              flex: 0.5,
              preventRedirect: true,
              renderCell: (params) => {
                const row = params.row;

                return (
                  <div className="flex items-center pr-4 space-x-5">
                    {permissions.includes(props?.theme?.permission) ?
                    <StatusSwitch status={row.status} url={`/translados/${row.id}/status`} />
                    :
                    <>{row.status ? 'Ativo' : 'Inativo'}</>
              }
                  </div>
                );
              }
            }
          ]}
        rows={rows}></Table>
    </div>
  </>
}

export default Index;
